<template> 
     <div class="con_content" >
         <div class="container" v-if="!list2Bool&&!checkGuid">
            <div class="container_top h_48">订单查询</div>
            
            <div class="w100 pad20 goods_bg goodsDiv padlr20">
                <div class="">
                
                    <div class="goodsInput">
                        <div class="gl">订单搜索：</div>
                        <Select v-model="select.select" @on-change="sc(select.select)" class="w180" >
                            <Option v-for="item in select.selects" :value="item.value" :key="item.value"  >{{ item.label }}</Option>
                        </Select>
                    </div>
                    <div class="goodsInput">
                        <Input   v-model="select.selectAll" @on-change="searchFun"    type='text' class="lft w180"  :placeholder="'请输入'+select.label"  clearable/>
                        <!-- <Button size="default"  type="primary" class="mL15" @click="searchFun()" >筛选</Button> -->
                    </div>
                   
                </div>
                  
            </div>

            <div>
                <Tabs type="card" v-model="card" :animated="false" >
                    <TabPane label="全部"   name="6"></TabPane>
                    <TabPane label="待付款" name="0"></TabPane>
                    <TabPane label="待发货" name="1"></TabPane>
                    <TabPane label="已发货" name="2"></TabPane>
                    <TabPane label="已完成" name="3"></TabPane>
                    <TabPane label="已关闭" name="4"></TabPane>
                </Tabs>
                
                <query1   @checkGuid="checkGuidFun"  @modal1="modal1Fun"  :type="card" :search="select.selectAll" ref="query1"></query1>
            </div>

        </div>

        <!-- 订单发货 -->
        <Modal                              
            v-model="modal1"
            title="订单发货"
            
            class-name="vertical-center-modal"
            width="850"
        >
            <div slot="footer" >     
                <Button v-if="setLoad.check == 1" type='primary' size='large' @click='modal1 = false;set_btn()'>发货</Button>
            </div>

         
            <RadioGroup v-model="setLoad.check">
                <span class="fw600">发货方式</span>  
                &nbsp;&nbsp;&nbsp;
                <Radio label="1">
                    <span>统一配送</span>
                </Radio>
                <Radio label="2">
                    <span>分批调配</span>
                </Radio>
            </RadioGroup>

            <div style="height:16px;width:100%;"></div>
            <div class="modal1_h" >
                <table class="old_table bottom16 bottom16">
                    <tr class="goods_bg goods_border_b">
                        <th class="a1">商品</th>
                        <th class="a2">数量</th>
                        <th class="a3">状态</th>
                        <th class="a4">运单号</th>    
                    </tr>
                    
                    <!-- 统一配送 -->
                    <tbody v-for="(item,index) in setLoad.list" :key="index"  >
                        <template v-if="setLoad.check == '1'">
                            <tr class="goods_border_b">
                                <td class="a1">
                                    <div class="flex alignItemsC ">
                                        <img class="bottom5 mR15" style="width:48px;height:48px;" :src="item.image" alt="">
                                        <div class="" >
                                            <p>{{item.name}}</p>
                                            <p>{{item.specsName}}</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="a2">{{item.num}}</td>
                                <td class="a3">
                                    <span v-if="!item.expressNum">待发货</span>
                                    <span v-if="item.expressNum">已发货</span>
                                </td>
                                <td class="a4">
                                    <span v-if="setLoad.data.expressNum">{{setLoad.data.expressNum}}</span>
                                    <span v-if="item.expressNum">{{item.expressNum}}</span>
                                </td>   
                            </tr>
                        </template>
                    </tbody> 
                    <!-- 分批调配  -->
                    <tbody v-for="(item,index2) in setLoad.list" :key="index2+'b'" class="goods_border_b" >
                        <template v-if="setLoad.check == '2'">
                            <tr class="">
                                <td class="a1">
                                    <div class="flex alignItemsC ">
                                        <img class="bottom5 mR15" style="width:48px;height:48px;" :src="item.image" alt="">
                                        <div class="" >
                                            <p>{{item.name}}</p>
                                            <p>{{item.specsName}}</p>
                                        </div>
                                    </div>
                                </td>
                                <td class="a2">{{item.num}}</td>
                                <td class="a3">
                                    <span v-if="!item.expressNum">待发货</span>
                                    <span v-if="item.expressNum">已发货</span>
                                    
                                </td>
                                <td class="a4">
                                    <span v-if="setLoad.data.expressNum">{{setLoad.data.expressNum}}</span>
                                    <span v-if="item.expressNum">{{item.expressNum}}</span>
                                </td>   
                            </tr>
                            <tr  class="" v-if="!item.expressNum">
                                <td colspan="4">
                                    
                                    <div class="flex bottom16 ">
                                        <div class="wp100 pad5 padl0 flex_shrink">发货方式</div>
                                        <div class="flex_grow ">
                                            <ul>
                                                <li class="flex">
                                                    <div class="wp80 pad5 flex_shrink">物流公司：</div>
                                                    <div class="rt pad5 padl0 flex_grow">
                                                        <Select v-model="setLoad.order[index2].order_c"  class="w180" >
                                                            <Option v-for="item in setLoad.selects" :value="item.com" :key="item.com"  >{{ item.title }}</Option>
                                                        </Select>
                                                    </div>
                                                </li>
                                                <li class="flex">
                                                    <div class="wp80 pad5 flex_shrink">快递单号：</div>
                                                    <div class="rt pad5 padl0 flex_grow"><Input   v-model="setLoad.order[index2].order_n"   type='text' class="lft w180"  placeholder="请输入快递单号"  /></div>
                                                </li>
                                                
                                            </ul>
                                        </div>
                                        <div class="flex flexC wp400">
                                            <Button @click="setLoad.index2 = index2;setLoad.guid2=item.orderCommodityGuid;set_btn()">发货</Button>
                                        </div>
                                        
                                    </div> 
                                </td>
                            </tr>
                        </template>
                    </tbody>              
                               
                </table>

                <div class="flex bottom16" v-if="setLoad.check == '1'">
                    <div class="wp100 pad5 padl0 flex_shrink">发货方式</div>
                    <div class="flex_grow ">
                        <ul>
                            <li class="flex">
                                <div class="wp80 pad5 flex_shrink">物流公司：</div>
                                <div class="rt pad5 padl0 flex_grow">
                                    <Select v-model="setLoad.order_c"  class="w180" >
                                        <Option v-for="item in setLoad.selects" :value="item.com+'_'" :key="item.com"  >{{ item.title }}</Option>
                                    </Select>
                                </div>
                            </li>
                            <li class="flex">
                                <div class="wp80 pad5 flex_shrink">快递单号：</div>
                                <div class="rt pad5 padl0 flex_grow"><Input   v-model="setLoad.order_n"   type='text' class="lft w180"  placeholder="请输入快递单号"  /></div>
                            </li>
                                
                        </ul>
                    </div>
                </div> 
                <div class="flex bottom16" v-if="setLoad.data">
                    <div class="wp100 pad5 padl0 flex_shrink">配送信息</div>
                    <div class="flex_grow ">
                        <ul v-if="setLoad.data.address">
                            <li class="flex">
                                <div class="wp80 pad5 flex_shrink">配送方式：</div>
                                <div class="pad5 padl0 flex_grow">快递</div>
                            </li>
                            <li class="flex" >
                                <div class="wp80 pad5 flex_shrink">收货人：</div>
                                <div class="pad5 padl0 flex_grow">{{setLoad.data.address.name}}</div>
                            </li>
                            <li class="flex" >
                                <div class="wp80 pad5 flex_shrink">收货地址：</div>
                                <div class="pad5 padl0 flex_grow">
                                    {{setLoad.data.address.pName}} {{setLoad.data.address.aName}} {{setLoad.data.address.cName}} {{setLoad.data.address.detail}}
                                </div>
                            </li>  
                        </ul>
                    </div>
                </div>  
 
            </div>
          
        </Modal>

        <!-- 子组件 -->
        <list2 v-if="list2Bool" ></list2>
        <query2 :guid="checkGuid" @checkGuid="checkGuidFun2" @modal1="modal1Fun" v-if="checkGuid"></query2>

     </div>
</template> 
<script>
    import query1 from './querys/query1.vue'
    import query2 from './querys/query2.vue'


    import { mapState,mapMutations,mapGetters } from 'vuex';
    import list2 from '../user/list2.vue'

    export default {
        name:'query',
        data () {
            return { 
                list2Bool: false,
                check1: '2',

                select:{    
                    select: 0,
                    label: '订单编号',
                    selectAll: null,
                    selects: [
                        {
                            value:0,
                            label: '订单编号'
                        }
                    ],
                },
                
                card: '6',
                checkGuid: null,

                modal1: false,

                setLoad: {         //发货弹窗                            
                    check: '1',    // '1'统一配送，'2'分批调配
                    data: {},
                    list: [],
                    order_c: '',            //订单公司
                    order_num: '',          //订单号
                    selects: [],

                    guid2: null,   //分批调配单个商品的guid
                    index2: 0,
                    order: [      //分批调配单个商品的 物流公司+订单号
                        {order_c: '',order_n: ''}
                    ]     
                },
                
            }
        },
        components:{ 'query1': query1,'query2': query2, 'list2':list2},
        watch:{
            '$store.state.checkGuid2':function(){
                this.$store.state.checkGuid2?this.list2Bool = true:this.list2Bool = false;
            },
            
        },
        computed: {
           
        },
        methods: {
           load(){
               this.$myAjax.get('admin/service/mail/express/get').then(res => {
                    this.setLoad.selects = res.data.data;
                    // console.log('aa',this.setLoad.selects)
               })
           },
           set_load(){
                this.$myAjax.get('admin/service/mail/order/info/get?guid='+this.guid).then(res => {
                    this.setLoad.data = res.data.data;
                    this.setLoad.list  = res.data.data.orderCommodity;

                    let order = [];
                    let len = this.setLoad.list.length;
                    for(let i=0;i<len;i++){
                        order.push({
                            order_c:this.setLoad.list[i].expressCom,
                            order_n:this.setLoad.list[i].expressNum
                        })
                    }
                    this.setLoad.order = order;
                    // console.log('order',this.setLoad.order)
                })
           },
           set_btn(){
               
                let data;
                if(this.setLoad.check == 1){
                    data = {
                        guid: this.guid,
                        expressCom: this.setLoad.order_c.replace('_',''),
                        expressNum: this.setLoad.order_n,
                        type: 1
                    }
                }else{
                    data = {
                        guid: this.setLoad.guid2,
                        expressCom: this.setLoad.order[this.setLoad.index2].order_c,
                        expressNum: this.setLoad.order[this.setLoad.index2].order_n,
                        type: 2
                    }
                } 
                // console.log(999,this.setLoad.index2,this.setLoad.order[this.setLoad.index2],data)
                this.$myAjax.post('admin/service/mail/express/add?route=/layout/goods/query/set',this.$ajaxNull.post(data)).then(res => {
                   if(this.setLoad.check == 1){
                       this.$refs.query1.load(); 
                   }else{
                       this.set_load();
                       this.$refs.query1.load();
                   }
                 
                })
           },
           sc(){
               
               let selects = this.select.selects;
               let len = selects.length;
               for(let i=0;i<len;i++){
                   if( selects[i].value == this.select.select ){
                       this.select.label = selects[i].label
                   }
               }
           },
            searchFun(){  //筛选
                
                this.card = '6';
                this.$refs.query1.searchFun(this.select.selectAll);
            },
            
            checkGuidFun(data){            // query1 checkGuid 
                this.checkGuid = data;
                
            },
            checkGuidFun2(data){            // query2 checkGuid 
                this.checkGuid = data;
            },
            modal1Fun(data){
                // console.log('modal1Fun',data);
                this.modal1 = data.setbool;
                this.modal2 = data.delbool;
                this.guid   = data.guid;

                this.set_load();
            },
          
        },
      
        mounted: function(){
            this.load();
           
        }
    }
</script>  
<style scoped>
    .w180{
        width: 180px;
    }
    .w80{
        width: 80px;
    }
    .w20{
        width: 20px;
    }

    .a1{
        width: 40%;
        padding: 12px 20px;
    }
    .a2,.a3,.a4{
        width: 20%;
        padding: 12px 20px;
    }
    
    .rt{
        position: relative;
        top: -4px;
    }
</style>
     